import { useEffect, useState } from 'react';
import { nextLiveDateRefreshMs, songDateLabel } from '../lib/formatting';

/**
 * A live song/version date label derived from `createdAt` while the item is recent.
 *
 * The stored `date` field is still used as the fallback for items with no truthful timestamp,
 * but recent rows should tick forward while the app stays open rather than freezing at the
 * string they were born with.
 */
export function useLiveDateLabel(createdAt: string | undefined, fallback: string): string {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const waitMs = nextLiveDateRefreshMs(createdAt, now);
    if (waitMs === null) return;
    const timer = window.setTimeout(() => setNow(Date.now()), waitMs);
    return () => window.clearTimeout(timer);
  }, [createdAt, now]);

  return songDateLabel(createdAt, fallback, now);
}
